import { useHistory } from "react-router-dom";
import moment from "moment";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Chip from "@mui/material/Chip";

const Organization = (props) => {
    const { id, name, email, phone, created_by, created_at, isActive } = props.org;
    const history = useHistory();

    const gotoDetails = () => history.push(`/organization/details/${id}`);

    return (
        <TableRow
            hover
            onClick={gotoDetails}
            sx={{ cursor: "pointer" }}
        >
            <TableCell sx={{ fontWeight: 600 }}>{name}</TableCell>
            <TableCell sx={{ color: "text.secondary" }}>{email}</TableCell>
            <TableCell sx={{ color: "text.secondary" }}>{phone}</TableCell>
            <TableCell sx={{ color: "text.secondary" }}>{created_by}</TableCell>
            <TableCell sx={{ color: "text.secondary", whiteSpace: "nowrap" }}>
                {moment(created_at).format("MMM DD, YYYY, hh:mm A")}
            </TableCell>
            <TableCell>
                {isActive ? (
                    <Chip label="Active" size="small" color="success" variant="filled" />
                ) : (
                    <Chip label="Inactive" size="small" color="default" variant="outlined" />
                )}
            </TableCell>
        </TableRow>
    );
};

export default Organization;
